import { createAction } from 'redux-actions';
/** Overwrites the store state. Do not use outside of storybook */ export const setFirstTimeFlags = createAction('@@firstTimeFlags/SET_FLAGS', (payload)=>payload);
/** Drop a particular FTUE flag */ export const dropFirstTimeFlag = createAction('@@firstTimeFlags/DROP_FLAG', (payload)=>payload);
/** Drop a particular FTUE flag, but with less annoying API (identical in
 * effect to dropFirstTimeFlag) */ export const dropFirstTimeFlagSimple = (flag, redirectTo)=>dropFirstTimeFlag({
        flag,
        redirectTo
    });
/** Unset a particular FTUE flag in the store only.
 * Does NOT persist on backend, do not use unless you know what you're doing. */ export const unsetFirstTimeFlag = createAction('@@firstTimeFlags/UNSET_FLAG', (flag)=>({
        flag
    }));

//# sourceMappingURL=actions.js.map